<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="55%"
            height="100%"
            no-click-animation
            >
            <v-card class="pa-3">
                <CardTitle :title="page_title" />
                <v-data-table
                    :headers="headers"
                    :items="desserts"
                    hide-default-footer
                    class="elevation-1"
                    >
                    <template v-slot:top>
                        <v-toolbar flat color="white" class="mt-1">
                            <div class="flex-grow-1">{{ propsGolfName }}</div>
                            <div class="flex-grow-1">{{ propsPlanName }}</div>
                        </v-toolbar>
                    </template>
                    <!-- <template v-slot:item.btn="{ item }">
                        <v-btn @click="displayRemoveOverLay(item)">削除</v-btn>
                    </template> -->
                    <template v-slot:[`item.btn`]="{ item }">
                        <v-btn
                            :disabled="btn[1].isActive"
                            @click="openChangeChild(item)"
                            >変更</v-btn>
                    </template>
                </v-data-table>
                <v-pagination
                    class="my-2"
                    v-model="page"
                    :length="pageCount"
                    :total-visible="7"
                    @input="clickPagination"
                />
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-4" text @click="closeModal">閉じる</v-btn>
                    <v-btn
                        :disabled="btn[2].isActive"
                        color="green darken-4"
                        text
                        @click="openAddChild">追加</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <PlanFee
            :feeID="feeID"
            :propsPlanId="propsPlanId"
            :propsPlanName="propsPlanName"
            :dialog="feeDialog"
            :receivedGolfCourse="golfCourse"
            :receivedGolfCourseName="propsGolfName"
            :modeStatus="modeStatus"
            :received="passTo"
            :propsReleaseStart="propsReleaseStart"
            @close="closeChild"
        />
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
// mixins
import { authorityMixin } from '@/views/authorityMixin';
// graghql
import { GET_PLAN_FEE_LIST } from '@/constants/plan';
import PlanFee from './PlanFee';

export default {
    components: {
        CardTitle,
        PlanFee
    },
    mixins: [authorityMixin],
    props: {
        dialog: {
            type: Boolean
        },
        golfCourse: {
            type: String
        },
        propsGolfName: {
            type: String
        },
        propsPlanId: {
            type: String
        },
        propsPlanName: {
            type: String
        },
        addD: {
            type: Object
        },
        propsReleaseStart: {
            type: String
        }
    },
    data () {
        return {
            // 削除確認用ポップアップ表示に関する制御値
            removeOverlay: false,
            // 登録画面の表示値
            feeDialog: false,
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理中かどうか
                processing: false
            },
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: '総額', value: 'total_fee', align: 'center', sortable: false },
                { text: '料金', value: 'base_fee', align: 'center', sortable: false },
                { text: '2B料金（平日）', value: 'add_fee_2b_weekday', align: 'center', sortable: false },
                { text: '2B料金（休日）', value: 'add_fee_2b_weekend', align: 'center', sortable: false },
                { text: '3B料金（平日）', value: 'add_fee_3b_weekday', align: 'center', sortable: false },
                { text: '3B料金（休日）', value: 'add_fee_3b_weekend', align: 'center', sortable: false },
                { text: '消費税', value: 'tax_sales', align: 'center', sortable: false },
                { text: '利用税', value: 'tax_usage', align: 'center', sortable: false },
                { text: 'その他', value: 'tax_others', align: 'center', sortable: false },
                { text: '', align: 'center', value: 'btn', sortable: false, width: '150' }
            ],
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: '料金設定一覧',
            // ID
            feeID: '',
            // 現在の日付
            Now: '',
            modeStatus: '',
            // 税
            taxSales: 0,
            taxUsageSelection: [],
            taxOthersSelection: [],
            taxSalesName: '',
            taxUsageName: '',
            taxOthersName: '',
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '変更', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true }
            ],
            vue_id: 'SCR0027',
            passTo: {
                baseFee: '',
                totalFee: '',
                displayTaxSales: ''
            },
            page: 1,
            pageCount: 0,
            // offset
            beginRow: 0,
            // 一覧の最大表示値
            limitRows: 10,
            // 金額データのカウント
            count: 0
        };
    },
    async created () {
        this.admin = await this.getLoginAdmin();
        await this.getAuthorityList();
    },
    watch: {
        // 親からデータが渡ってきたときに発火
        async propsPlanId () {
            if (this.propsPlanId !== '') {
                await this.getFeeList();
            }
        }
    },
    methods: {
        /** ----------------------------------------------
         * プランに紐づく特典を取得
         * 発火タイミングはwatchで処理
         * ---------------------------------------------- */
        async getFeeList () {
            this.$apollo.mutate({
                mutation: GET_PLAN_FEE_LIST,
                variables: {
                    plan_id: this.propsPlanId,
                    limit: this.limitRows,
                    offset: this.beginRow
                }
            }).then(res => {
                const data = res.data.getPlanFeeList.PlanFeeList;
                this.count = res.data.getPlanFeeList.count;
                this.pageCount = Math.ceil(this.count / this.limitRows);
                this.desserts.splice(0, this.desserts.length);
                data.forEach(res => {
                    res.add_fee_2b_weekday = this.addD.addFee2bWeekday;
                    res.add_fee_2b_weekend = this.addD.addFee2bWeekend;
                    res.add_fee_3b_weekday = this.addD.addFee3bWeekday;
                    res.add_fee_3b_weekend = this.addD.addFee3bWeekend;
                    Object.keys(res).forEach(cellName => {
                        res[cellName] = res[cellName].toLocaleString();
                    });
                    this.desserts.push(res);
                });
            });
        },
        /** ----------------------------------------------
         * 子コンポーネントを表示する
         * ---------------------------------------------- */
        openAddChild () {
            this.modeStatus = 'addMode';
            this.feeDialog = true;
        },
        /** ----------------------------------------------
         * 子コンポーネントを表示する
         * ---------------------------------------------- */
        openChangeChild (item) {
            this.feeID = item.fee_id;
            this.passTo.baseFee = item.base_fee.replace(',', '');
            this.passTo.totalFee = item.total_fee.replace(',', '');
            this.passTo.displayTaxSales = item.tax_sales.replace(',', '');
            this.modeStatus = 'changeMode';
            this.feeDialog = true;
        },
        /** ----------------------------------------------
         * 子コンポーネントを閉じる
         * ---------------------------------------------- */
        closeChild () {
            this.feeDialog = false;
            this.getFeeList();
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        closeModal () {
            this.desserts.splice(0, this.desserts.length);
            this.$emit('close', ['fees_count', this.count]);
        },
        /** --------------------------------------------
        * ページネーション処理
        * ---------------------------------1----------- */
        clickPagination () {
            this.beginRow = this.page * this.limitRows - this.limitRows;
            this.getFeeList();
        }
    }
};
</script>
